// extracted by mini-css-extract-plugin
export default {"errorContainer":"errorContainerBllWk","errorContent":"errorContentog97I"};